import React from "react";
import { Link } from "react-router-dom";
import './Generic.css'; 

const Conservation = () => {

  return (
    <div>
        <blockquote>
        <h1>Danger in the Congo</h1>
        <h2>Ongoing projects</h2>
        <p>Bonobo Painting</p>

        <h2>Research Foundation</h2>
        <p><Link to="/SueBiblio">Selected Publications of E. Sue Savage-Rumbaugh</Link></p>
        </blockquote>
    </div>
  )
  };

  export default Conservation;